import { AlertTriangle, X } from 'lucide-react';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onProceed: () => void;
  message?: string;
}

/**
 * Modal shown when user tries to navigate away with unsaved changes.
 */
export default function UnsavedChangesModal({
  isOpen,
  onCancel,
  onProceed,
  message = 'You have unsaved changes. Are you sure you want to leave?',
}: UnsavedChangesModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-xl max-w-md w-full p-6 shadow-2xl">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-5 h-5 text-amber-500" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Unsaved Changes
            </h3>
          </div>
          <button
            onClick={onCancel}
            className="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
            aria-label="Close modal"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {message}
        </p>

        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            className="btn btn-secondary flex-1"
          >
            Stay on Page
          </button>
          <button
            type="button"
            onClick={onProceed}
            className="btn bg-amber-500 text-white hover:bg-amber-600 flex-1"
          >
            Leave Page
          </button>
        </div>
      </div>
    </div>
  );
}
